<div #FieldWrapper
	class="form-group custom-field-wrapper ui-g-12 ui-md-{{gridColumns || 6}}">
	<div *ngIf="field.props.label"
		class="input-label"
		[ngStyle]="{'width': labelStyleWidth}">
		<label [attr.for]="id">
			<strong *ngIf="field.props.hideLabel !== true">
				{{field.props.label}}
			</strong>
			<ng-container
				*ngIf="field.props.tooltip != null && field.props.tooltip.length > 0">
				<app-common-icon-tooltip
					[content]="field.props.tooltip"
					[field]="field"
					[escape]="false">
				</app-common-icon-tooltip>
			</ng-container>
			<ng-container
				*ngIf="field.props.externalLink != null && field.props.externalLink.length > 0
					&& field.props.externalLinkTooltip != null">
				<app-common-icon-tooltip
					[content]="field.props.externalLinkTooltip"
					[field]="field"
					[externalLink]="field.props.externalLink">
				</app-common-icon-tooltip>
			</ng-container>
			<ng-container
				*ngIf="(field.props.tooltipImageDataPromise != null && field.props.tooltipImageDataPromise.length > 0) ||
					(field.props.tooltipImageValue != null && field.props.tooltipImageValue.length > 0)">
				<custom-image-display
					[context]="field.props.context"
					[value]="field.props.tooltipImageValue"
					[dataPromise]="field.props.tooltipImageDataPromise"
					[altText]="field.props.tooltipImageAltText"
					[description]="field.props.tooltipImageDescription"
					[isClickable]="field.props.tooltipImageClickable"
					[isVisuallyDisabled]="field.props.tooltipImageVisuallyDisabled"
					[iconMode]="true"
					class="tooltip-inline-image">
				</custom-image-display>
			</ng-container>
		</label>
	</div>

	<div class="p-input-div">
		<ng-template
			#fieldComponent>
		</ng-template>
		<span *ngIf="field.formControl.status === 'PENDING'">
			<i class="fa fa-fw fa-spin fa-spinner validation-spinner">
			</i>
		</span>
	</div>
</div>